export default __webpack_public_path__ + "static/media/TheHole.15f99583.jpg";